import { HttpInterceptorFn } from "@angular/common/http";
import { inject } from "@angular/core";
import { AuthService } from "../../features/login/services/auth.service";
import { EnvConstants } from "../../shared/constants/env.constantes";
import { ChardiApiConfiguration } from "../models/chardi-api-configuration.model";

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  if (req && req.url && /^http/.test(req.url)) {
    if ((EnvConstants.CMS_API_URL && req.url.startsWith(EnvConstants.CMS_API_URL))
        || (EnvConstants.API_URL && req.url.startsWith(EnvConstants.API_URL))) {
      const authService = inject(AuthService);
      const token = authService.accessToken();
      if (!token) return next(req);
      const isExcluded = excludedUrls.some(url => req.url.startsWith(url));
      if (isExcluded) {
        return next(req);
      }

      const authReq = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
        }
      });
      return next(authReq);
    } else if (EnvConstants.CHARDI_API_URL && req.url.startsWith(EnvConstants.CHARDI_API_URL)){
      const chardiApiConfig = inject(ChardiApiConfiguration);
          const token = btoa(`${chardiApiConfig.username}:${chardiApiConfig.password}`);
      
          if (!token) return next(req);
          const isExcluded = excludedUrls.some(url => req.url.startsWith(url));
          if (isExcluded) {
              return next(req);
          }
      
          const authReq = req.clone({
              setHeaders: {
                  Authorization: `Basic ${token}`,
              }
          });
      
          return next(authReq);
    }
  };

  return next(req);
}

const excludedUrls = [
  'https://maps.googleapis.com',
  'https://places.googleapis.com'
];